var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-wrapper',{attrs:{"sidebar":_vm.sidebar}},[(_vm.sidebar.name)?_c(_vm.sidebar.name,{tag:"component",attrs:{"sidebar":_vm.sidebar}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }